import type { FC } from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { translate } from "app/filters/i18nFilter";
import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import { getWebsiteTypeOptions } from "app/pages/keyword-analysis/Organic";

import { sourceTypes } from "../widget-filters/KeywordAnalysisGraphDashboardWidgetFilters";
import { CategoriesDashboardFilter } from "../widget-filters/components/CategoriesDashboardFilter";
import { DomainsDashboardFilter } from "../widget-filters/components/DomainsDashboardFilter";
export const ALL_CATEGORIES_DEFAULT_ID = "All";

const orderByOptions = [
    { id: "Share desc", text: "Traffic Share", sort: "Share" },
    { id: "Change desc", text: "Change", sort: "Change" },
];

interface ITableKeywordAnalysisDashboardWidgetFiltersProps {
    widgetFilters: any;
    changeFilter: (filters: any) => void;
    widgetPreview: any;
    widgetKeys: any;
}
export const TableKeywordAnalysisDashboardWidgetFilters: FC<ITableKeywordAnalysisDashboardWidgetFiltersProps> = (
    props,
) => {
    const { widgetFilters, changeFilter, widgetPreview, widgetKeys } = props;
    const getSelectedFilters = () => {
        return Object.entries(widgetFilters).map(([name, value]) => ({ name, value }));
    };
    const selectedSourceType = widgetFilters?.sourceType ?? sourceTypes[0].id;
    const websiteTypeOptions = [
        {
            id: ALL_CATEGORIES_DEFAULT_ID,
            text: "topsites.table.site.functionality.filter.all.website.types",
        },
        ...getWebsiteTypeOptions(),
    ].map((item) => ({ ...item, text: translate(item.text) }));

    const handleClicksSourceTypeChange = ({ id }: { id: string }) => {
        changeFilter([
            ...getSelectedFilters(),
            {
                name: "sourceType",
                value: id,
            },
        ]);
    };

    const handleOrderByChange = ({ id, sort }: { id: string; sort: string }) => {
        const selectedFilters = [...getSelectedFilters()];
        changeFilter([
            selectedFilters,
            {
                name: "orderBy",
                value: id,
            },
            {
                name: "sort",
                value: sort,
            },
        ]);
    };

    const handleCategoryChange = (item) => {
        changeFilter([
            ...getSelectedFilters(),
            {
                name: "category",
                value: item?.id === ALL_CATEGORIES_DEFAULT_ID ? undefined : item?.id,
            },
        ]);
    };

    const handleDomainsChange = (item) => {
        changeFilter([
            ...getSelectedFilters(),
            {
                name: "domains",
                value: item,
            },
        ]);
    };
    const onSelectWebsiteType = (item) => {
        changeFilter([
            ...getSelectedFilters(),
            {
                name: "funcFlag",
                value: item?.id === ALL_CATEGORIES_DEFAULT_ID ? undefined : item?.id,
            },
        ]);
    };

    const dropdownItems = Object.entries(sourceTypes).map(([id, text]) => ({
        id,
        text,
    }));

    return (
        <div className="filters">
            <div className="dynamicFilter">
                <h5>
                    <I18n>home.dashboards.wizard.filters.orderBy</I18n>
                </h5>
                <StatefulDropdown
                    items={orderByOptions}
                    selectedId={widgetFilters?.orderBy ?? orderByOptions[0].id}
                    onSelect={handleOrderByChange}
                />
            </div>
            <div className="dynamicFilter">
                <h5>
                    <I18n>home.dashboards.wizard.filters.trafficType</I18n>
                </h5>
                <StatefulDropdown
                    items={sourceTypes}
                    selectedId={selectedSourceType}
                    onSelect={handleClicksSourceTypeChange}
                />
            </div>
            <div
                key="websiteType"
                className="dynamicFilter"
            >
                <h5>
                    <I18n>home.dashboards.wizard.filters.WebsiteType</I18n>
                </h5>
                <StatefulDropdown
                    key="websiteTypeFilter"
                    items={websiteTypeOptions}
                    selectedId={widgetFilters?.funcFlag ?? websiteTypeOptions[0].id}
                    onSelect={onSelectWebsiteType}
                    hasSearch={false}
                />
            </div>
            <div className="dynamicFilter">
                <h5>
                    <I18n>home.dashboards.wizard.filters.website.industries</I18n>
                </h5>
                <CategoriesDashboardFilter
                    categories={widgetPreview?.Filters?.Categories?.Category}
                    customCategories={widgetPreview?.Filters?.Categories?.CustomCategory}
                    selectedCategory={widgetFilters?.category}
                    onSelect={handleCategoryChange}
                />
            </div>
            <div className="dynamicFilter">
                <h5>
                    <I18n>keywords.analysis.filters.domains.projects.button</I18n>
                </h5>
                <DomainsDashboardFilter
                    domainsList={widgetPreview?.Filters?.DomainsList}
                    domains={widgetFilters?.domains}
                    onSelect={handleDomainsChange}
                    keyword={widgetKeys[0]?.id}
                />
            </div>
        </div>
    );
};
